import React from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';
import { useRouter } from 'next/router';
import { applyLocaleToUrl } from '@/utils/formatters';

import {
  AspectRatioKeeper,
  Box,
  Image,
  Typography,
} from '@kohler-dsm-library/kohler-core';

function VisualFilterCard(props) {
  const { locale } = useRouter()
  const {
    imageUrl="",
    alt="",
    name="",
    ctas = [],
    src=""
  } = props;
  const titleObj = { text: name };
  const imageObj = {
    src: imageUrl,
    alt: alt,
    width: 293,
    height: 197,
  };
  return (
    <Box
      component="div"
      className={clsx(styles['koh-images-caption'])}
    >
      {/* IMAGE */}
      <a href={src} className={styles['koh-product-image-link']}>
        <AspectRatioKeeper aspectRatio="4:3">
          <Image {...imageObj} />
        </AspectRatioKeeper>
      </a>

      {/* CAPTION */}
      {titleObj?.text && (
        <div className={styles['koh-carousel-imageCaption']}>
          <Typography component="p" className="">
            {titleObj.text}
          </Typography>
        </div>
      )}

      {/* CTAs */}
      {ctas.length > 0 && (
        <div className={styles['koh-product-carousel-ctas']}>
          {ctas.map((cta, i) => (
            <a
              key={i}
              href={applyLocaleToUrl(cta?.fields?.url, locale)}
              className={styles[`koh-product-carousel-${cta?.fields?.buttonType}-btn`]}
            >
              {cta?.fields?.label}
            </a>
          ))}
        </div>
      )}
    </Box>
  );
}

export default VisualFilterCard;